import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { dbRealtime } from './firebase'; // Import the Realtime Database
import { Navbar } from './navbar';
import "./Dashboard.css";

const Dashboard = () => {
  const [deviceCount, setDeviceCount] = useState(0);
  const [dataKeyCount, setDataKeyCount] = useState(0);
  const [mobileNumberCount, setMobileNumberCount] = useState(0);
  const [smsCount, setSmsCount] = useState(0); // State to store the total SMS count
  const [lastEnteredMobile, setLastEnteredMobile] = useState(''); // State to store the last entered mobile number

  useEffect(() => {
    const dataRef = ref(dbRealtime, 'Data'); // Reference to the 'Data' path in your database
    const mobileRef = ref(dbRealtime, 'MobileNumber'); // Reference to the 'MobileNumber' path in your database

    const handleDataChange = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        
        // Count number of devices
        const devices = Object.keys(dataObj);
        setDeviceCount(devices.length);

        // Count number of immediate data keys
        let keyCount = 0;
        // Total SMS counter
        let totalSmsCount = 0;

        devices.forEach(device => {
          if (dataObj[device]) {
            // Count immediate child keys
            keyCount += Object.keys(dataObj[device]).length;

            // Count SMS messages if there is a 'receivedSMS' field (assuming 'receivedSMS' is the field containing SMS data)
            if (dataObj[device].receivedSMS) {
              totalSmsCount += Object.keys(dataObj[device].receivedSMS).length;
            }
          }
        });

        setDataKeyCount(keyCount);
        setSmsCount(totalSmsCount);

        // Count number of devices with a mobile number
        let mobileCount = 0;
        devices.forEach(device => {
          if (dataObj[device] && dataObj[device].mobileno) {
            mobileCount++;
          }
        });
        setMobileNumberCount(mobileCount);
      } else {
        console.log('No data available.');
      }
    };

    const handleMobileNumberChange = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        const keys = Object.keys(dataObj);
        if (keys.length > 0) {
          const lastKey = keys[keys.length - 1];
          const lastMobileNumber = dataObj[lastKey].mobileNumber;
          setLastEnteredMobile(lastMobileNumber);
        }
      } else {
        console.log('No mobile number data available.');
      }
    };

    // Set up listeners for both data paths
    const dataListener = onValue(dataRef, handleDataChange);
    const mobileListener = onValue(mobileRef, handleMobileNumberChange);

    return () => {
      // Clean up listeners on unmount
      dataListener();
      mobileListener();
    };
  }, []);

  return (
    <div className="content">
      <Navbar />
      <h1 className='text-center hed'>Welcome to Your Dashboard</h1>
      <div className="widgets text-center">
        <div className="widget">
          <h3>SMS</h3>
          <p>Total Devices: {deviceCount}</p>
          {/* <p>Total SMS: {smsCount}</p> */}
        </div>
        <div className="widget">
          <h3>Data</h3>
          <p>Total Data: {dataKeyCount}</p>
        </div>
       
      </div>

      <div className="widget">
          <h3>Number</h3>
          <p>Current Forwarding Mobile Number: {lastEnteredMobile}</p>
        </div>
    </div>
  );
};

export default Dashboard;
